export default "__VITE_ASSET__CU5V7eeq__"